import { ReactNode } from 'react';
import { Card, Col } from 'react-bootstrap';

type Props = {
  title: string;
  subtitle?: string;
  styles: any;
  customClass: any;
  children?: ReactNode;
  backgroundColor?: string;
  backgroundImage?: string;
  onClick?: () => void;
};

const IndicatorCard = ({
  title,
  subtitle,
  styles,
  children,
  customClass,
  backgroundColor,
  backgroundImage,
  onClick,
}: Props) => {
  return (
    <Col md={3}>
      <Card
        onClick={onClick}
        className={customClass}
        style={{
          backgroundColor: backgroundColor || '',
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : '',
          backgroundPosition: 'top center',
          backgroundSize: 'cover',
          ...styles,
        }}
      >
        <Card.Body>
          {children ? children : null}
          {title ? <Card.Subtitle>{title}</Card.Subtitle> : null}
        </Card.Body>
        {subtitle ? (
          <Card.Footer>
            <span>{subtitle}</span>
          </Card.Footer>
        ) : null}
      </Card>
    </Col>
  );
};

export default IndicatorCard;
